import { useParams, useLocation } from 'react-router-dom';
import BannerIndiceDiPenetrazionePage from '../../../../components/report/listaDriverPage/indice-di-penetrazione-dei-mercati/BannerIndiceDiPenetrazionePage';
import ContainerIndiceDiPenetrazionePage from '../../../../components/report/listaDriverPage/indice-di-penetrazione-dei-mercati/ContainerIndiceDiPenetrazionePage';
import { useReport } from '../../../../api/hooks/useReport';
import { useElementIndiciDiPentrazione } from '../../../../api/hooks/useElementIndiciDiPentrazione';
import DownloadReportButton from '../../../../components/report/listaDriverPage/DownloadReportButton';


const IndiceDiPenetrazioneMercatiPage = () => {
    const { name, driverRoute } = useParams<{ name: string; driverRoute: string }>();
    const location = useLocation();
  const { id, driverId } = location.state || {};
  const { report, loading: loadingReport, error: errorReport } = useReport(id);
    
    
  const { elements: indici, loading: loadingElements, error: errorElements } = useElementIndiciDiPentrazione(id, driverId); 
  if (loadingReport || loadingElements) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
      </div>
    );
  }

  if (errorReport || errorElements) {
    return <div className="text-red-600">{errorReport || errorElements}</div>;
  }
  const indiceID = indici.length > 0 ? indici[0].id : null;

    return (
      <div className="flex flex-col bg-gray-50">
        <BannerIndiceDiPenetrazionePage report={report} title={driverRoute!} reportId={id} />
        <div className="px-8 lg:px-16 py-8">
          <div className="flex justify-end mb-4">
            <DownloadReportButton reportId={id} componentId={driverId} />
          </div>
          <ContainerIndiceDiPenetrazionePage
            indici={indici}
            reportId={name!}
            driverRoute={driverRoute!}
            indiceID={indiceID!}
            id={id}
            driverId={driverId}
          />
        </div>
      </div>
    );
  };
  

export default IndiceDiPenetrazioneMercatiPage